import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import {tokensForThemeProvider} from '@forecast-it/design-system';

export const PageHeader = ({children}) => {
	return <PageHeaderStyle>{children}</PageHeaderStyle>;
};

PageHeader.propTypes = {
	children: PropTypes.node,
};

// The heading token is a complete block — family, weight, size, letter-spacing, line-height — because the
// token set has no family-only value. Its size and weight are the same 20px/500 the title has always
// rendered at, so the typeface is the only change.
//
// The default set is pinned explicitly and never taken from the active theme: the sets differ in weight as
// well as family, so following the theme would also change the weight wherever a different theme is
// active. Every other token consumer here reads this same set directly.
//
// Resolved per render rather than at module scope, because this module is re-exported from the
// web-components barrel, which is imported far beyond the handful of surfaces that render a title — a read
// at import time would run everywhere that barrel is loaded, and fail wherever the design system is stubbed.
const headingBlock = () => tokensForThemeProvider?.sky?.sys?.font?.heading?.['4'];

const PageHeaderStyle = Styled.h1`
    color: #535353;
    ${headingBlock}
    margin: 0;
`;
